const toBase64 = (string) => {
  const buffer = Buffer.from(string);
  return buffer.toString('base64');
};

export default toBase64;
